export default {
      id: "menu__dashboard_fill-usage",
      viewBox: "0 0 28 31",
      url: __webpack_public_path__ + "img/icons.svg#menu__dashboard_fill",
      toString: function () {
        return this.url;
      }
    }